/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration } from '@gh/core-data';

import { ContactDeliveryMethod } from '../contacts';
import { ScheduleSupervisorSupplierListItemDto } from './scheduling-suppliers.dto';

export const ScheduleSupervisorSupplierListItemMapper = entity<ScheduleSupervisorSupplierListItemDto>({
  sendBy: enumeration(ContactDeliveryMethod),
});
